import React from "react";
import ReactDOM from "react-dom";
import "../../styles/MergedChargesTooltip.css";

const ImagePreviewModal = ({ data, onClose, onPrev, onNext }) => {
  if (!data) return null;

  return ReactDOM.createPortal(
    <div className="image-modal" onClick={onClose}>
      <div
        className="image-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="carousel-arrow left modal-arrow" onClick={onPrev}>
          ‹
        </button>

        <img src={data.img} alt={data.title} />

        <button className="carousel-arrow right modal-arrow" onClick={onNext}>
          ›
        </button>

        <div className="image-modal-text">
          <h4>{data.title}</h4>
          <p>{data.desc}</p>
        </div>

        <span className="full-screen-close-btn" onClick={onClose}>✕</span>
      </div>
    </div>,
    document.body
  );
};


export default ImagePreviewModal;
